import { Injectable } from '@angular/core';
import { IncidentPageTabState } from './incident-page-tab.state';

@Injectable({ providedIn: 'root' })
export class IncidentsPageStateService {
  get openedTabState(): IncidentPageTabState {
    return this._openedTabState;
  }
  private _openedTabState = new IncidentPageTabState(true);

  get closedTabState(): IncidentPageTabState {
    return this._closedTabState;
  }
  private _closedTabState = new IncidentPageTabState(false);

  get currentTab(): number {
    return this._currentTab;
  }
  set currentTab(value: number) {
    this._currentTab = value;
  }
  private _currentTab: number = 0;
}
